import React, { useEffect } from 'react';
import styles from './pratiquemodafitness2.module.scss';

import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import SiteIcon from '../../icons/siteIcon.tsx';

const Pratiquemodafitness2: React.FC = () => {

    useEffect(() => {
        const updateHeight = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div className={styles.pratiquemodafitness2}>

            <div className={styles.container}>
                <div className={styles.infoSection}>
                    <div className={styles.links}>
                        <a href="https://wa.me/5517996736993" target="_blank" rel="noopener noreferrer">
                            <WhatsappIcon height="30" color="#ffffff" />
                            WHATSAPP
                        </a>
                        <a href="https://www.instagram.com/pratiquemodafitness" target="_blank" rel="noopener noreferrer">
                            <InstagramIcon height="24" color="#ffffff" />
                            INSTAGRAM
                        </a>
                        <a href="https://www.pratiquemodafitness.com.br" target="_blank" rel="noopener noreferrer">
                            <SiteIcon height="24" color="#ffffff" />
                            SITE
                        </a>
                        <a href="https://maps.app.goo.gl/wuwtHXsTjX7YYCrs9" target="_blank" rel="noopener noreferrer">
                            <MapsIcon height="30" color="#ffffff" />
                            LOCALIZAÇÃO
                        </a>
                        <a href="#">
                            <WhatsappIcon height="30" color="#ffffff" />
                            GRUPO VIP
                        </a>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Pratiquemodafitness2;
